<template>
  <div class="fulfilled-wrapper">
    <div class="header">
      <p>{{ `ข้อมูลการปิดงาน` }}</p>
    </div>
    <div class="content">
      <div class="item">
        <p class="title">{{ `เวลาปิดงาน :` }}</p>
        <p class="value">{{ closeJobTimeText }}</p>
      </div>
      <div class="item" v-if="appointment.providerFulfilledMessage">
        <p class="title">{{ `รายละเอียดการให้บริการ :` }}</p>
        <p class="value">{{ appointment.providerFulfilledMessage }}</p>
      </div>
      <div class="item" v-if="appointment.providerFulfilledImages">
        <p class="title">{{ "รูปปิดงาน :" }}</p>
        <div class="image-wrapper">
          <img
            v-for="(image, index) in appointment.providerFulfilledImages"
            :key="index"
            :src="image"
            @click="handleShowImage(image)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertDateTimeToTimeText } from "@/lib/dateTime";

export default {
  props: ["appointment"],
  computed: {
    closeJobTimeText() {
      return convertDateTimeToTimeText(this.appointment.providerFulfilledAt);
    }
  },
  methods: {
    handleShowImage(image) {
      window.open(image, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.fulfilled-wrapper {
  display: flex;
  flex-direction: column;
  height: auto;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background-color: $white;
  overflow: hidden;

  > .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 24px;
    border-bottom: 1px solid #e6e6e6;

    p {
      color: $black;
      font-size: 18px;
      font-weight: bold;
    }
  }

  > .content {
    display: flex;
    flex-direction: column;
    grid-gap: 4px;
    padding: 16px 24px;

    > .item {
      display: flex;
      flex-direction: column;

      > .title {
        color: #808080;
        font-size: $font-14;
      }

      > .value {
        color: $black;
        font-size: $font-16;
      }

      > .image-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
      }

      img {
        border: 1px solid $color-light-gray-1;
        border-radius: 4px;
        width: 55px;
        height: 55px;
        margin-top: 8px;
        margin-right: 8px;
        object-fit: cover;
      }
    }
  }
}

@media (max-width: ($m-size - 1)) {
  .fulfilled-wrapper {
    > .content {
      > .item {
        img {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .fulfilled-wrapper {
    > .header {
      padding: 8px 16px;
    }

    > .content {
      padding: 16px;

      > .item {
        img {
          width: 45px;
          height: 45px;
        }
      }
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .fulfilled-wrapper {
    > .header {
      padding: 8px 16px;

      p {
        font-size: 16px;
      }
    }

    > .content {
      padding: 16px;

      > .item {
        > .title {
          font-size: $font-12;
        }

        > .value {
          font-size: $font-14;
        }

        img {
          width: 45px;
          height: 45px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/JobDetailFulfilled.vue